<template>
  <div>
    <b-form-select :options="options" v-model="modelComp">
    </b-form-select>
    <!-- {{model}} -->
  </div>
</template>

<script>
export default {
  name: "PendencyGenerationNotifyDropdown",
  components: {},
  props: {
    model: {
      type: Boolean,
      default: false,
    },
    showZero: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  computed: {
    modelComp: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      },
    },
    options() {
      if (this.showZero) {
        return [
          { value: null, text: "" },
          { value: false, text: "Não" },
          { value: true, text: "Por e-mail" },
        ];
      }
      return [
          { value: false, text: "Não" },
          { value: true, text: "Por e-mail" },
      ];
    },
  },
  methods: {},
};
</script>
